<template>
  <v-input :error-messages="errorMessages" value="1">
    <v-layout style="position: relative;">
      <div
        style="max-width: 133%;
    transform: translateX(-7px) scale(.75);
    pointer-events: auto;
    position: absolute;"
      >
        <span>
          <RequiredMark />
          <span>誕生日</span>
        </span>
      </div>
      <v-select
        v-model="year"
        placeholder="年"
        hide-details
        :items="yearOptions"
        :error-messages="errorMessages"
        @change="onChange"
      />
      <v-select
        v-model="month"
        placeholder="月"
        hide-details
        :items="monthOptions"
        :error-messages="errorMessages"
        @change="onChange"
      />
      <v-select
        v-model="day"
        placeholder="日"
        :items="dayOptions"
        :error-messages="errorMessages"
        hide-details
        @change="onChange"
      />
    </v-layout>

    <template #message="{message}">
      {{ message }}
    </template>
  </v-input>
</template>

<script>
import moment from 'moment'
import RequiredMark from '@/components/RequiredMark'

export default {
  name: 'BirthdaySelect',
  components: { RequiredMark },
  props: {
    value: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    year: null,
    month: null,
    day: null,
  }),
  computed: {
    yearOptions() {
      let r = []
      const max = moment().year()
      for (let y = max; y >= 1900; --y) {
        r.push(y)
      }
      return r
    },
    monthOptions() {
      let r = []
      for (let m = 1; m <= 12; ++m) {
        r.push(m)
      }
      return r
    },
    dayOptions() {
      let r = []
      for (let d = 1; d <= 31; ++d) {
        r.push(d)
      }
      return r
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.year = null
          this.month = null
          this.day = null
        } else {
          const [y, m, d] = String(value).split('-')
          this.year = Number(y) || null
          this.month = Number(m) || null
          this.day = Number(d) || null
        }
      },
    },
  },
  methods: {
    onChange() {
      const y = this.year
      const m = this.month
      const d = this.day
      if (!y || !m || !d) {
        // this.$emit('input', null)
      } else {
        let sy = String(y)
        let sm = String(m)
        let sd = String(d)
        if (sm.length < 2) sm = '0' + sm
        if (sd.length < 2) sd = '0' + sd
        const v = `${sy}-${sm}-${sd}`
        this.$emit('input', v)
      }
    },
  },
}
</script>
